(function () {
  'use strict';
  let current = null;
  const escape = value => String(value).replace(/[&<>"']/g, char => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[char]));
  const guides = () => window.ACTICLEAR_ORIGINAL_GUIDES || {};
  const frameId = 'acticlear-original-guide';
  const assetUrl = key => {
    const map = window.ACTICLEAR_ASSETS || {};
    return new URL(map[key] || map[key.replace(/^assets\//, '')] || key, document.baseURI).href;
  };
  const route = (id, section) => {const q=new URLSearchParams();if(section)q.set('section',section);const current=new URLSearchParams(location.hash.split('?')[1]||'');if(location.hash.split('?')[0]==='#/guides/'+id&&current.has('variant'))q.set('variant',current.get('variant'));return '#/guides/'+encodeURIComponent(id)+(q.size?'?'+q.toString():'');};
  const pageUrl = hash => location.href.split('#')[0] + hash;

  function dispose() {
    if (!current) return;
    current.disposed = true;
    if (current.observer) current.observer.disconnect();
    if (current.mutationObserver) current.mutationObserver.disconnect();
    if (current.frame && current.onLoad) current.frame.removeEventListener('load', current.onLoad);
    if (current.doc && current.onClick) current.doc.removeEventListener('click', current.onClick);
    if (current.onResize) window.removeEventListener('resize', current.onResize);
    if (current.raf) cancelAnimationFrame(current.raf);
    if (current.scrollRaf) cancelAnimationFrame(current.scrollRaf);
    current = null;
  }

  function html(id) {
    const guide = guides()[id];
    if (!guide) return '';
    return '<iframe id="' + frameId + '" class="original-guide-frame" title="' + escape(guide.title) + '" data-guide-id="' + escape(id) + '" scrolling="no" style="display:block;width:100%;max-width:none;min-width:0;height:1200px;border:0;margin:0;padding:0;background:#f2f1ed"></iframe>';
  }

  function sectionTarget(state, requested) {
    const doc = state.doc;
    let id = String(requested || '').replace(/^#/, '').replace(/^guide-section-/, '');
    if (/^\d+$/.test(id)) id = state.guide.legacySections[Number(id)] || id;
    if (id === 'before-use') id = 'use';
    if (id === 'guide-scope') id = 'guide-content';
    if (id === 'downloads') id = 'guide-contact';
    if (id === 'dose') id = doc.getElementById('dosage') ? 'dosage' : 'dose-help';
    const step = /^use-step-(\d+)$/.exec(id);
    return step ? doc.querySelectorAll('#use .instruction-card')[Number(step[1]) - 1] : doc.getElementById(id);
  }

  function stickyOffset() {
    if (Number.isFinite(window.ACTICLEAR_GUIDE_HEADER_OFFSET)) return window.ACTICLEAR_GUIDE_HEADER_OFFSET;
    let bottom = 0;
    document.querySelectorAll('header, [data-sticky-header]').forEach(el => {
      const style = getComputedStyle(el), box = el.getBoundingClientRect();
      if (style.position === 'sticky' && box.height > 0) bottom = Math.max(bottom, box.height + Math.max(0, parseFloat(style.top) || 0));
      else if (style.position === 'fixed' && box.top <= 1 && box.bottom > 0) bottom = Math.max(bottom, box.bottom);
    });
    return bottom;
  }

  function scrollToSection(state, requested) {
    if (!requested || state.disposed || !state.doc) return;
    const target = sectionTarget(state, requested);
    if (!target) return;
    if (state.scrollRaf) cancelAnimationFrame(state.scrollRaf);
    state.scrollRaf = requestAnimationFrame(() => {
      if (state.disposed) return;
      state.measure();
      state.frame.contentWindow.scrollTo(0, 0);
      const top = window.scrollY + state.frame.getBoundingClientRect().top + target.getBoundingClientRect().top - stickyOffset() - 18;
      window.scrollTo({top: Math.max(0, top), behavior: 'instant'});
      target.setAttribute('tabindex', '-1');
      target.focus({preventScroll: true});
    });
  }

  function parentDestination(guide, href) {
    if (href.charAt(0) === '#') return route(guide.id, href.slice(1));
    const match = /^\.\.\/([^/]+)\/index\.html(?:\?[^#]*)?(?:#(.*))?$/.exec(href);
    if (!match) return null;
    const next = Object.values(guides()).find(item => item.sourceDirectory === match[1]);
    return next ? route(next.id, match[2] || '') : null;
  }

  function mount(id, params) {
    dispose();
    const guide = guides()[id], frame = document.getElementById(frameId);
    if (!guide || !frame) return false;
    const section = params && typeof params.get === 'function' ? params.get('section') : params && params.section;
    const state = {id, guide, frame, disposed: false, section};
    current = state;
    const source = new DOMParser().parseFromString(guide.html, 'text/html');
    source.querySelectorAll('img[src]').forEach(img => {
      const key = guide.media[img.getAttribute('src')];
      if (!key) throw new Error('Missing original guide media mapping: ' + img.getAttribute('src'));
      img.setAttribute('src', assetUrl(key));
    });
    source.querySelectorAll('a[href]').forEach(a => {
      const destination = parentDestination(guide, a.getAttribute('href'));
      if (destination) {
        a.setAttribute('data-guide-destination', destination);
        a.setAttribute('href', pageUrl(destination));
        a.setAttribute('target', '_top');
      }
    });
    state.onLoad = () => {
      if (state.disposed) return;
      state.doc = frame.contentDocument;
      if (!state.doc) return;
      const main = state.doc.getElementById('guide-content');
      if (!main) return;
      state.measure = () => {
        if (state.disposed) return;
        const height = Math.ceil(main.getBoundingClientRect().height);
        if (height > 0 && frame.style.height !== height + 'px') frame.style.height = height + 'px';
      };
      const scheduleMeasure = () => {
        if (state.disposed) return;
        if (state.raf) cancelAnimationFrame(state.raf);
        state.raf = requestAnimationFrame(state.measure);
      };
      state.onClick = event => {
        const anchor = event.target.closest('a[data-guide-destination]');
        if (!anchor || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const next = anchor.getAttribute('data-guide-destination');
        if (location.hash === next) scrollToSection(state, new URLSearchParams(next.split('?')[1] || '').get('section'));
        else location.hash = next;
      };
      state.doc.addEventListener('click', state.onClick);
      state.observer = new ResizeObserver(scheduleMeasure);
      state.observer.observe(main);
      state.onResize = scheduleMeasure;
      window.addEventListener('resize', state.onResize);
      state.measure();
      const settle = () => {
        if (state.disposed) return;
        state.measure();
        scrollToSection(state, section);
      };
      const imageReady = Array.from(main.querySelectorAll('img')).map(img => img.complete ? Promise.resolve() : new Promise(resolve => {
        img.addEventListener('load', resolve, {once: true});
        img.addEventListener('error', resolve, {once: true});
      }));
      settle();
      Promise.all([state.doc.fonts ? state.doc.fonts.ready : Promise.resolve(), ...imageReady]).then(settle);
      frame.dataset.guideReady = 'true';
    };
    frame.addEventListener('load', state.onLoad);
    frame.srcdoc = '<!doctype html><html lang="en"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>' + escape(guide.title) + '</title><link rel="stylesheet" href="' + escape(assetUrl(guide.stylesheet)) + '"></head><body class="guide-preview">' + source.body.innerHTML + '</body></html>';
    return true;
  }

  window.ACTICLEAR_GUIDE_VIEW = {html, mount, dispose};
}());
